import { isDev } from "@/helper/env";

export const getAppUrl = () => {
  const prefix = isDev ? "http://" : "https://";

  return `${prefix}${process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL}`;
};
